<style lang="stylus">
    .max-topmenu
        display flex
        .max-topmenu--item
            display flex
            justify-content center
            align-items center
            min-width 80px
            padding 6px 10px
            background #F2F4F9
            border-radius 4px
            cursor pointer
            @media screen and (max-width: 980px)
                display none
            p
                font-size 12px
                line-height 16px
                color #222
                user-select none
            &:not(.last-child)
                margin-right 12px
            &.active
                background rgba(1, 127, 255, 0.10)
                p
                    color #017FFF
            &:hover
                p
                    color #017FFF
        .max-topmenu-back
            display flex
            align-items center
            span
                font-size 14px
                color #000
        .max-topmenu--short
            display none
            @media screen and (max-width: 980px)
                display block
            .max-topmenu--option
                display flex
                justify-content center
                align-items center
                min-width 92px
                padding 0 16px
                background rgba(1, 127, 255, 0.10)
                height 28px
                border-radius 4px
                cursor pointer
                p
                    font-size 12px
                    color #017FFF
                    user-select none
                    margin-right 4px
    .dark-theme_pcview-topmenu
        .max-topmenu--item
            background rgba(255, 255, 255, 0.08)
            p
                color #E6E6E6
            &.active
                background rgba(1, 119, 240, 0.20)
        .max-topmenu-back
            span
                color #fff
</style>

<template>
    <div class="max-topmenu" :class="{ 'dark-theme_pcview-topmenu': isPCDarkMode == 2 }">
        <div v-if="searchMode" class="max-topmenu-back" @click="searchBack">
            <img :src="require(`@/home/assets/pcview${isPCDarkMode == 2 ? '-dark' : ''}/back.svg`)" alt="" />
            <span>{{ $t("back") }}</span>
        </div>
        <template v-else>
            <div class="max-topmenu--item" :class="{ active: menuID == item.id }" v-for="item in menuList" @click="clickMenu(item.id)">
                <p>{{ item.label }}</p>
            </div>

            <Dropdown
                class="max-topmenu--short"
                :data="menuList"
                :dark="isPCDarkMode == 2"
                :selfStyle="'left: 0; right: auto; top:30px;'"
                :activeId="menuID"
                @selectData="clickMenu"
            >
                <div class="max-topmenu--option">
                    <p>{{ menuList[menuID].label }}</p>
                    <img :src="require(`@/home/assets/pcview${isPCDarkMode == 2 ? '-dark' : ''}/menuarr.svg`)" alt="" />
                </div>
            </Dropdown>
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dropdown from "./parts/Dropdown.vue";

    @Component({
        components: {
            Dropdown,
        },
    })
    export default class Temp extends Vue {
        @Prop()
        disable;
        @Prop()
        searchMode;
        get menuList() {
            const arr = [
                {
                    id: 0,
                    name: "file",
                    label: "",
                },
                {
                    id: 1,
                    name: "star",
                    label: "",
                },
                {
                    id: 2,
                    name: "share",
                    label: "",
                },
                {
                    id: 3,
                    name: "collect",
                    label: "",
                },
                {
                    id: 4,
                    name: "publish",
                    label: "",
                },
                {
                    id: 5,
                    name: "trash",
                    label: "",
                },
            ];
            arr.forEach((item) => {
                item.label = this.$tc(item.name);
            });
            return arr;
        }
        menuID = 0;
        clickMenu(id: number) {
            if (this.disable) return;
            this.menuID = id;
            this.$emit("setMenu", id);
        }
        clickMenu2(e) {
            console.log(e);
        }
        searchBack() {
            this.$emit("searchBack");
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "file": "全部文件",
        "star": "星标文件",
        "share": "分享给我",
        "collect": "我的收藏",
        "publish": "我的发布",
        "trash": "回收站",
        "back": "返回"
    },
    "en": {
        "file": "All Files",
        "star": "Starred File",
        "share": "Share With Me",
        "collect": "Favorites",
        "publish": "Publish",
        "trash": "Recycle Bin",
        "back": "Return"
    },
    "fr": {
        "file": "Tous les documents",
        "star": "Fichier étoile",
        "share": "Partager avec moi",
        "collect": "ma collection",
        "publish": "Publier",
        "trash": "Corbeille",
        "back": "retour"
    },
    "de": {
        "file": "Alle Dateien",
        "star": "Sternendatei",
        "share": "Teile mit mir",
        "collect": "meine Sammlung",
        "publish": "Veröffentlichen",
        "trash": "Papierkorb",
        "back": "Rückkehr"
    },
    "jp": {
        "file": "すべてのファイル",
        "star": "スターファイル",
        "share": "私との共有",
        "collect": "お気に入り",
        "publish": "投稿",
        "trash": "ゴミ箱",
        "back": "戻る"
    },
    "es": {
        "file": "Todos los archivos",
        "star": "Archivo destacado",
        "share": "Compartido con",
        "collect": "mi colección",
        "publish": "Publicar",
        "trash": "Papelera",
        "back": "regreso"
    },
    "pt": {
        "file": "Todos os Ficheiros",
        "star": "Documentos estrelados",
        "share": "Compartilhe comigo",
        "collect": "minha coleção",
        "publish": "Publicar",
        "trash": "Pasta de Reciclagem",
        "back": "Retorna"
    },
    "it": {
        "file": "Tutti i File",
        "star": "File Stella",
        "share": "Condividi con me",
        "collect": "la mia collezione",
        "publish": "Pubblicare",
        "trash": "Cestino",
        "back": "ritorno"
    },
    "tw": {
        "file": "全部檔案",
        "star": "星標檔案",
        "share": "分享給我",
        "collect": "我的收藏",
        "publish": "我的發佈",
        "trash": "回收站",
        "back": "返回"
    },
    "kr": {
        "file": "모든 파일",
        "star": "별표 파일",
        "share": "공유된 파일",
        "collect": "즐겨찾기",
        "publish": "게시한 파일",
        "trash": "휴지통",
        "back": "돌아가기"
    }
}
</i18n>
